import {
  useUserRoleResourceStore,
  useUserPermissionResourceStore,
  useCurrentProjectRoleResourceStore, useRightsVersionResourceStore,
  useCurrentProjectPermissionResourceStore
} from '@/stores/useResourcePermissionStore';
import { useCurrentProjectSwitchStore, useUserSwitchStore } from '@/stores/useSwitchStore';
import { Features } from '@/stores/createSwitchStore';
import { useProjectSwitchStore } from '@/stores/useProjectDataStore';

export const updateUserRoleWithVuex = (roles?: {
  roleCode: string,
  enabled: boolean
}[]) => {
  const store = useUserRoleResourceStore();
  store.setResources(roles?.filter(i => i.enabled).map(i => i.roleCode) || []);
};

export const updateUserPermissionWithVuex = (account?: {
  orgRolePermissionVOList?: {
    code: string
  }[]
}) => {
  const store = useUserPermissionResourceStore();
  store.setResources(account?.orgRolePermissionVOList?.map(i => i.code) || []);
};

export const updateCurrentProjectRoleWithVuex = (roles?: {
  roleCode: string,
  enabled: boolean
}[]) => {
  const store = useCurrentProjectRoleResourceStore();
  store.setResources(roles?.filter(i => i.enabled).map(i => i.roleCode) || []);
};

export const updateCurrentProjectPermissionWithVuex = (permissions?: {
  code: string
}[]) => {
  const store = useCurrentProjectPermissionResourceStore();
  store.setResources(permissions?.map(i => i.code) || []);
};

export const updateUserSwitchWithVuex = (features?: Features) => {
  const store = useUserSwitchStore();
  store.setFeatures(features || {});
};

export const updateCurrentProjectSwitchWithVuex = (features?: Features) => {
  const store = useCurrentProjectSwitchStore();
  store.setFeatures(features || {});
};
export const updateCurrentProjectSwitchWithChangeProject = (id: number) => {
  const projectSwitchStore = useProjectSwitchStore();
  const features = projectSwitchStore.getById(id);
  updateCurrentProjectSwitchWithVuex(features);
};

export const updateProjectSwitchWithVuex = (features?: Record<number, Features>) => {
  const store = useProjectSwitchStore();
  store.setAll(features || {});
};

export const updateRightsVersionWithVuex = (res?: {
  productSchemeVO?: {
    schemeType?: number,
  }
}) => {
  const store = useRightsVersionResourceStore();
  const getRightsName = (type?: number) => {
    switch (type) {
      case 0: return 'free';
      case 1: return 'trial';
      case 2: return 'standard';
      case 3: return 'professional';
      case 5: return 'private';
      default: return 'unknown';
    }
  };
  store.setResources([getRightsName(res?.productSchemeVO?.schemeType)]);
};

